import React, { useEffect, useMemo } from 'react';
import { AdminContentBlock, Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import AppBarCMS from '../../../../basic/Navigation/AppBarCMS/AppBarCMS';
import RoomsResponsibleForm from './RoomsResponsibleForm.jsx';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Form from '../../../../antd/form/Form/Form';
import {
  useGetRoomResponsiblePersonsDetailQuery,
  useSaveRoomResponsiblePersonsMutation,
} from '../../../../../redux/services/rooms_responsible';
import { useGetDepartmentsQuery } from '../../../../../redux/services/departments';
import { useGetTeachersQuery } from '../../../../../redux/services/users';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const RoomResponsibleEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  const { data: roomResponsibleDetail, isLoading } =
    useGetRoomResponsiblePersonsDetailQuery(id, { skip: !isEdit });

  const { data: departments, isLoading: isLoadingDepartments } =
    useGetDepartmentsQuery();
  const { data: teachers, isLoading: isLoadingTeachers } =
    useGetTeachersQuery();

  const [saveRoomResponsible, { isSuccess: isSaveSuccess }] =
    useSaveRoomResponsiblePersonsMutation();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsRoomResponsible);
    }
  }, [isSaveSuccess]);

  const pageTitle = isCreate
    ? t('Pridanie zodpovednej osoby')
    : t('Úprava zodpovednej osoby');

  useEffect(() => {
    document.title = pageTitle + ' - FRI CMS';
  }, []); // Runs on mount

  const initials = {
    department_id: roomResponsibleDetail?.department_id,
    person_ids: roomResponsibleDetail?.responsible_ids ?? [],
  };

  const departmentsForSelect = useMemo(() => {
    if (!departments) return [];
    return departments.map((department) => ({
      label: department.title_sk,
      value: department.id,
    }));
  }, [departments]);

  const teachersForSelect = useMemo(() => {
    if (!teachers) return [];
    return teachers.map((person) => ({
      label: person.fullName,
      value: person.person_id,
    }));
  }, [teachers]);

  if (
    isEdit &&
    (!roomResponsibleDetail ||
      isLoading ||
      isLoadingDepartments ||
      isLoadingTeachers)
  ) {
    return <Spinner />;
  }

  return (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={routes.cmsRoomResponsible}
        backUrlTooltip={t('Zodpovedné osoby')}
        permissionsBasic="room-responsible"
      />
      <div style={{ margin: '10px' }}>
        <AdminContentBlock
          icon="fa fa-sticky-note-o"
          link={routes.cmsRoomResponsible}
          title={pageTitle}
        >
          <Form
            initialValues={initials}
            onFinish={(values) => {
              const data = {
                department_id: values.department_id,
                person_id: values.person_ids,
              };
              const payload = { data };
              if (!isCreate) {
                payload.id = roomResponsibleDetail.id;
              }
              saveRoomResponsible(payload);
            }}
          >
            <RoomsResponsibleForm
              departments={departmentsForSelect}
              persons={teachersForSelect}
            />
          </Form>
        </AdminContentBlock>
      </div>
    </>
  );
};

export default RoomResponsibleEdit;
